import { Button } from "components/DesignSystem/Button/Button";
import { LongArrowRight } from "components/icons/LongArrowRight";
import { VARIANCE_REPORT_STATUS } from "constants/financialClosing";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { Link } from "react-router-dom";
import AIGenerateButtonStar from "static/images/AIGenerateButtonStar.svg";
import {
  FinancialClosingDetail,
  useUpdateVarianceReportStatusMutation,
} from "store/apis/financialClosing";

type VarianceReportActionsProps = {
  financialClosingItem: FinancialClosingDetail;
};

export const VarianceReportActions = ({
  financialClosingItem,
}: VarianceReportActionsProps) => {
  const { link } = useConstructInternalLink();
  const entityId = useCurrentEntityId();
  const [updateVarianceReportStatus] = useUpdateVarianceReportStatusMutation();

  const isGenerated =
    financialClosingItem.variance_report_status ===
    VARIANCE_REPORT_STATUS.GENERATED;

  const reportLink = link(`/${financialClosingItem.uuid}/variance-report`, {
    includeUrl: true,
  });

  const handleGenerateClick = () => {
    void updateVarianceReportStatus({
      entityId,
      financialClosingId: financialClosingItem.uuid,
    });
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Link
        to={reportLink}
        onClick={isGenerated ? undefined : handleGenerateClick}
      >
        <Button
          customType="secondary"
          size="small"
          leftIcon={
            !isGenerated && (
              <img
                src={AIGenerateButtonStar}
                alt="AIGenerateButtonStar"
                className="t-size-3.5"
              />
            )
          }
          rightIcon={isGenerated && <LongArrowRight strokeWidth="1.2" />}
        >
          {isGenerated ? "View Flux" : "Generate Flux"}
        </Button>
      </Link>
    </div>
  );
};
